import { render, staticRenderFns } from "./product-code-switch-maintenance.vue?vue&type=template&id=ed04dc06&"
import script from "./product-code-switch-maintenance.vue?vue&type=script&lang=js&"
export * from "./product-code-switch-maintenance.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports